<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Area Chief Patron Sir Visited Proyash-Chattogram
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        Area Chief Patron of Proyash-Chattogram Maj Gen Mizanur Rahman Shamim,
        BP, OSP, ndc, psc visited Proyash-Chattogram on 7 February 2023...
        <br />
        He was delighted by the performance of children with special needs. His
        magnanimity touched the hearts of students, teachers and parents. <br />
        We are confident that under his direction and supervision
        Proyash-Chattogram will continue its momentum towards a sustainable and
        inclusive society.
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
